import { useNavigate } from "react-router-dom";

const RefundPolicy = () => {
  const navigate = useNavigate();
  return (
    <main className="dashboardLayoutSubSection rounded-xl">
      <section className="max-w-4xl mx-auto px-6 py-10">
        <button
          onClick={() => navigate(-1)}
          className="bg-myButtonBg hover:bg-myLabelText cursor-pointer text-white px-6 py-2 rounded-md"
        >
          Back
        </button>
        <h1 className="text-3xl font-bold text-gray-800 mb-2 text-center">
          Refund & Cancellation Policy
        </h1>
        <p className="text-sm text-gray-500 text-center mb-6">
          Last Updated: 27th September, 2025
        </p>

        <p className="text-gray-600 mb-6">
          At LLB360, a product of Saadruso Internet Media Pvt Ltd., we are
          committed to providing law students with high-quality learning
          resources, mock tests, and academic support. This Refund &
          Cancellation Policy explains the conditions under which subscriptions
          or purchases may be refunded or canceled.
        </p>

        <ol className="list-decimal list-inside space-y-4 text-gray-700">
          <li>
            <span className="font-semibold text-gray-800">General Policy</span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                All purchases made on LLB360 are considered final and
                non-refundable, except as explicitly stated in this Policy.
              </li>
              <li>
                By purchasing a subscription, you acknowledge that you are
                accessing digital content, which is delivered immediately upon
                purchase and therefore is generally not eligible for refund
                under applicable laws.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Eligibility for Refunds
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                Duplicate Payment: If you are accidentally charged more than
                once for the same subscription.
              </li>
              <li>
                Technical Issues: If you are unable to access paid content due
                to a verified technical error on our platform, and our support
                team is unable to resolve the issue within 7 business days.
              </li>
              <li>
                Incorrect Plan Purchase: If you purchased the wrong subscription
                plan (e.g., Semester instead of Subject-wise), and request a
                correction within 48 hours of purchase without having accessed
                significant content.
              </li>
              <li>
                <span className="font-semibold text-gray-800">
                  Refund requests will not be entertained for:
                </span>
                <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
                  <li>Change of mind after purchase.</li>
                  <li>Exam results not meeting personal expectations.</li>
                  <li>
                    Failure to use the Services within the subscription period.
                  </li>
                  <li>Unauthorized use of your account by third parties.</li>
                </ul>
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Cancellation of Subscriptions
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                Auto-renewal subscriptions may be canceled anytime from your
                account settings before the renewal date.
              </li>
              <li>
                Canceling prevents future charges but does not entitle you to a
                refund for the current billing cycle.
              </li>
              <li>
                Once canceled, you will retain access until the end of the paid
                term.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">Refund Process</span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                To request a refund, email contact@llb360.com with your order
                details and the reason for the request.
              </li>
              <li>
                Approved refunds will be processed within 7–10 business days to
                your original payment method.
              </li>
              <li>Any bank or payment gateway charges are non-refundable.</li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Special Offers & Discounts
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                Payments made under special offers, promotions, or discounted
                subscriptions are non-refundable.
              </li>
              <li>
                Free trial users who upgrade to paid plans waive any right to
                refunds once the upgrade is processed.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">Contact Us</span>
            <p className="mt-2 text-gray-600">
              For refund or cancellation requests, please contact:
            </p>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>Saadruso Internet Media Pvt Ltd.</li>
              <li>Email: contact@llb360.com</li>
              <li>Phone: 7673937360</li>
              <li>
                Address: Plot # 28, Doyens Township, Serilingampally, Hyderabad
                – 500 019
              </li>
            </ul>
          </li>
        </ol>
      </section>
    </main>
  );
};

export default RefundPolicy;
